import { Chip, Stack } from "@mui/material";
import CloudIcon from "@mui/icons-material/Cloud";
import CloudOffIcon from "@mui/icons-material/CloudOff";
import { useTranslation } from "i18n-fe";
import { useScoreContext } from "../context/ScoreContext";

export default function OfflineIndicator() {
  const { online, toggleOnline, pendingSync } = useScoreContext();
  const { t } = useTranslation("score");
  return (
    <Stack direction="row" spacing={1} alignItems="center">
      <Chip
        data-testid="offline-toggle"
        // #1283 — SyncStatus deliberately renders NOTHING while online and
        // healthy, so its disappearance is no longer a usable "the outbox has
        // drained" signal for tests. This chip is always mounted and this
        // attribute changes no layout, so it carries that signal instead:
        // wait for [data-sync-pending="false"] to serialize against the
        // outbox rather than racing it.
        data-sync-pending={pendingSync > 0 ? "true" : "false"}
        size="small"
        icon={online ? <CloudIcon /> : <CloudOffIcon />}
        label={online ? t("status.online") : t("status.offline")}
        color={online ? "success" : "warning"}
        variant="filled"
        // Tapping forces offline/online (#423). Effective connectivity is
        // navigator.onLine AND this flag; the sync engine suspends the network
        // while forced offline and drains the outbox + hydrates on reconnect —
        // so toggling offline is seamless and toggling back syncs.
        onClick={toggleOnline}
        sx={{ cursor: "pointer", fontWeight: 600 }}
      />
    </Stack>
  );
}
